import { render, staticRenderFns } from "./ActivationBriefAgreementsView.vue?vue&type=template&id=a5227616&scoped=true&"
import script from "./ActivationBriefAgreementsView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefAgreementsView.vue?vue&type=script&lang=js&"
import style0 from "./ActivationBriefAgreementsView.vue?vue&type=style&index=0&id=a5227616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5227616",
  null
  
)

export default component.exports